/**
 * RazorPay Utility Functions
 * This file contains helper functions for RazorPay Payment Link integration
 */

import { toast } from 'react-toastify';

// Get Worker URL from environment variables
const WORKER_URL = process.env.REACT_APP_WORKER_URL || 'http://127.0.0.1:8787';

// Create a payment link with RazorPay
export const createPaymentLink = async ({
  amount,
  currency,
  name,
  email,
  phone,
  businessName,
  description
}) => {
  try {
    // Make API call to Cloudflare Worker to create payment link
    const response = await fetch(`${WORKER_URL}/api/create-payment-link`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount: amount * 100, // Convert to smallest currency unit (paise for INR)
        currency,
        customer: {
          name,
          email,
          contact: phone
        },
        description,
        callback_url: window.location.origin + '/donate?status=success',
        callback_method: 'get',
        notify: {
          sms: true,
          email: true
        }
      })
    });

    if (!response.ok) {
      throw new Error('Failed to create payment link');
    }

    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.error || 'Failed to create payment link');
    }
    
    // Redirect to the payment link
    window.location.href = data.short_url;
    
    return {
      success: true,
      paymentLinkId: data.id,
      shortUrl: data.short_url
    };
  } catch (error) {
    console.error('Payment link creation error:', error);
    return {
      success: false,
      error: error.message || 'Failed to create payment link'
    };
  }
};

// Verify payment status
export const verifyPayment = async (id) => {
  try {
    // Determine if this is a payment ID or payment link ID based on prefix
    const endpoint = id.startsWith('pay_') 
      ? `/api/verify-payment-by-id/${id}`
      : `/api/verify-payment/${id}`;

    const response = await fetch(`${WORKER_URL}${endpoint}`);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Payment verification failed');
    }

    // If we get a successful response from the API, return the data
    if (data.success) {
      return data;
    }

    // If success is false in the response, return error
    return {
      success: false,
      error: data.error || 'Payment verification failed'
    };
  } catch (error) {
    console.error('Error verifying payment:', error);
    return {
      success: false,
      error: error.message || 'Error verifying payment'
    };
  }
}; 